import '.a{display:grid;}.ssr-plugin'
import '.hv{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import Column from '@app/components/layout/Column'
import { Empty } from '@app/components/blocks/empty/Empty'
import PersonWithBinocularsImage from '@app/assets/images/person_with_binoculars.png'
import { StoredImage } from '@app/types/StoredImage'

export type KnowledgeHubModuleItem = {
  id: number
  slug: string
  title: string
  intro?: string
  images?: StoredImage[]
}

export const KnowledgeHubModulesSection = ({
  modules,
}: {
  modules: KnowledgeHubModuleItem[]
}) => {
  const t = useTranslations().app.knowledgeHubTab
  const title = t.title

  if (modules.length === 0) {
    return <Empty title={t.noModules} imageSrc={PersonWithBinocularsImage} />
  }

  return (
    <Column gap={'0.5rem'}>
      <Title.H4>{title}</Title.H4>
      <styled.div className="a hv g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {modules.map((item) => (
          <BlogCard
            key={item.id}
            title={item.title}
            intro={item.intro}
            image={item.images?.[0]}
            to={pages.knowledgeHubModule(item.slug)}
          />
        ))}
      </styled.div>
    </Column>
  )
}
